import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import { findAllQueues } from "../../services/queue.api";
import { listUsersSimple } from "../../services/users.api";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import { i18n } from "../../translate/i18n";
import { PRESETS } from "./useReportsData";

const useStyles = makeStyles((theme) => ({
  bar: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 12,
    padding: "14px 16px",
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  presets: { display: "flex", gap: 6, flexWrap: "wrap" },
  preset: {
    height: 34,
    padding: "0 14px",
    borderRadius: 17,
    border: `1px solid ${theme.palette.divider}`,
    background: "transparent",
    color: theme.palette.text.primary,
    fontSize: 13,
    fontWeight: 600,
    fontFamily: "inherit",
    cursor: "pointer",
  },
  presetOn: {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
    backgroundColor: theme.mode === "dark" ? "rgba(59,130,246,0.18)" : "#EEF2FF",
  },
  field: { minWidth: 170 },
  date: { width: 160 },
}));

const asList = (data, key) => (Array.isArray(data) ? data : data?.[key] || []);

/** Barra de filtros del tablero (doc 0447 §5): aplica a todas las pestañas. */
const FiltersBar = ({ filters, setPreset, setFilter }) => {
  const classes = useStyles();
  const { whatsApps } = useContext(WhatsAppsContext);
  const [queues, setQueues] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    let alive = true;
    findAllQueues().then(({ data }) => alive && setQueues(asList(data, "queues"))).catch(() => undefined);
    listUsersSimple().then(({ data }) => alive && setUsers(asList(data, "users"))).catch(() => undefined);
    return () => {
      alive = false;
    };
  }, []);

  const select = (key, label, options) => (
    <TextField
      select
      size="small"
      variant="outlined"
      label={label}
      value={filters[key]}
      onChange={(e) => setFilter(key, e.target.value)}
      className={classes.field}
    >
      <MenuItem value="">{i18n.t("reports.filters.all")}</MenuItem>
      {options.map((o) => (
        <MenuItem key={o.id} value={String(o.id)}>
          {o.name}
        </MenuItem>
      ))}
    </TextField>
  );

  return (
    <div className={classes.bar}>
      <div className={classes.presets} role="group" aria-label={i18n.t("reports.filters.period")}>
        {PRESETS.map((p) => (
          <button
            key={p}
            type="button"
            aria-pressed={filters.preset === p}
            className={`${classes.preset} ${filters.preset === p ? classes.presetOn : ""}`}
            onClick={() => setPreset(p)}
          >
            {i18n.t(`reports.filters.presets.${p}`)}
          </button>
        ))}
      </div>

      {filters.preset === "custom" && (
        <>
          <TextField
            type="date"
            size="small"
            variant="outlined"
            label={i18n.t("reports.filters.from")}
            value={filters.from}
            onChange={(e) => setFilter("from", e.target.value)}
            InputLabelProps={{ shrink: true }}
            className={classes.date}
          />
          <TextField
            type="date"
            size="small"
            variant="outlined"
            label={i18n.t("reports.filters.to")}
            value={filters.to}
            onChange={(e) => setFilter("to", e.target.value)}
            InputLabelProps={{ shrink: true }}
            className={classes.date}
          />
        </>
      )}

      {select("queueId", i18n.t("reports.filters.queue"), queues)}
      {select("userId", i18n.t("reports.filters.agent"), users)}
      {select("whatsappId", i18n.t("reports.filters.connection"), whatsApps || [])}
    </div>
  );
};

export default FiltersBar;
